// csNote page strings. Keys are read as $t('csNote.<key>').
// Server data (note text, names, channel/type codes in the table, done/pending status)
// is never translated - the status button text is also what put_and_getnotes() reads.
export default {
  en: {
    pageTitle: 'CS Note',
    close: 'Close',
    errorPrefix: 'Error: ',
    custInfo: {
      title: 'Customer info',
      name: 'Name',
      mainAddress: 'Main address',
      mainPhone: 'Main phone',
      otherAddresses: 'Other addresses',
      address: 'Address',
      phone: 'Phone',
      notesHistory: 'Notes history',
      week: 'Week',
    },
    newCust: {
      title: 'New customer',
      phone: 'Customer phone',
      phonePh: 'customer_phone',
      name: 'Customer name',
      namePh: 'customer_name',
      email: 'Email',
      emailPh: 'email',
      address: 'Address',
      addressPh: 'customer_address',
      submit: 'Create customer',
      errName: 'The customer Name is missing',
      errPhone: 'The customer Phone is missing',
      errAddress: 'The customer Address is missing',
      errEmail: 'The customer Email is missing',
      errPhoneDigits: 'The customer Phone must have 10 digits',
      errAddressLength: 'The customer Address must have at least 10 characters',
      errEmailInvalid: 'The customer Email is not valid',
    },
    massClose: {
      title: 'Mass close',
      good: 'Good to close',
      already: 'Already closed',
      notInWeek: 'Not in week',
      submit: 'Mass close',
      noneToClose: 'Error: none of these notes can be closed',
    },
    toolbar: {
      custInfo: 'Cust info',
      strike: 'Strike',
      strikeTitle: 'Strike through completed notes',
      searchPh: 'Search (3+ characters)',
      massClosePh: 'Mass close: paste ids',
      export: 'Export',
    },
    table: {
      openHistory: 'Open order history',
      yes: 'YES',
      no: 'NO',
    },
    col: {
      id: 'id',
      customer_phone: 'phone',
      customer_name: 'Name',
      channel_id: 'channel',
      description: 'description',
      type: 'type',
      is_month_order: 'MO',
      is_completed_string: 'done',
      created_by_id: 'by',
      week_id: 'week_id',
      created: 'created',
    },
    form: {
      custIdPh: 'custid',
      phonePh: 'phone',
      namePh: 'name',
      chPhone: 'phone',
      chFacebook: 'facebook',
      chOther: 'other',
      descriptionPh: 'Description',
      descriptionHint: 'Ctrl+Enter to create the note',
      typeOrder: 'order',
      typePayment: 'payment',
      typeShip: 'ship',
      typeCancel: 'cancel',
      typeOther: 'other',
      monthOrder: 'MO',
      create: 'Create',
    },
  },
  vi: {
    pageTitle: 'CS Note',
    close: 'Đóng',
    errorPrefix: 'Lỗi: ',
    custInfo: {
      title: 'Thông tin khách hàng',
      name: 'Tên',
      mainAddress: 'Địa chỉ chính',
      mainPhone: 'SĐT chính',
      otherAddresses: 'Địa chỉ khác',
      address: 'Địa chỉ',
      phone: 'SĐT',
      notesHistory: 'Lịch sử ghi chú',
      week: 'Tuần',
    },
    newCust: {
      title: 'Khách hàng mới',
      phone: 'SĐT khách hàng',
      phonePh: 'Số điện thoại (10 số)',
      name: 'Tên khách hàng',
      namePh: 'Tên khách hàng',
      email: 'Email',
      emailPh: 'email',
      address: 'Địa chỉ',
      addressPh: 'Địa chỉ khách hàng',
      submit: 'Tạo khách hàng',
      errName: 'Thiếu tên khách hàng',
      errPhone: 'Thiếu số điện thoại khách hàng',
      errAddress: 'Thiếu địa chỉ khách hàng',
      errEmail: 'Thiếu email khách hàng',
      errPhoneDigits: 'Số điện thoại phải có đủ 10 số',
      errAddressLength: 'Địa chỉ phải có ít nhất 10 ký tự',
      errEmailInvalid: 'Email không hợp lệ',
    },
    massClose: {
      title: 'Đóng hàng loạt',
      good: 'Có thể đóng',
      already: 'Đã đóng rồi',
      notInWeek: 'Không thuộc tuần này',
      submit: 'Đóng hàng loạt',
      noneToClose: 'Lỗi: Không có note nào thỏa điều kiện để close',
    },
    toolbar: {
      custInfo: 'Thông tin KH',
      strike: 'Gạch ngang',
      strikeTitle: 'Gạch ngang các note đã xong',
      searchPh: 'Tìm kiếm (từ 3 ký tự)',
      massClosePh: 'Đóng hàng loạt: dán id',
      export: 'Xuất file',
    },
    table: {
      openHistory: 'Mở lịch sử đơn',
      yes: 'CÓ',
      no: 'KHÔNG',
    },
    col: {
      id: 'id',
      customer_phone: 'SĐT',
      customer_name: 'Tên',
      channel_id: 'Kênh',
      description: 'Nội dung',
      type: 'Loại',
      is_month_order: 'Tháng',
      is_completed_string: 'Trạng thái',
      created_by_id: 'Người tạo',
      week_id: 'Tuần',
      created: 'Ngày tạo',
    },
    form: {
      custIdPh: 'mã KH',
      phonePh: 'SĐT',
      namePh: 'tên',
      chPhone: 'Điện thoại',
      chFacebook: 'Facebook',
      chOther: 'Khác',
      descriptionPh: 'Nội dung ghi chú',
      descriptionHint: 'Ctrl+Enter để tạo ghi chú',
      typeOrder: 'Đơn hàng',
      typePayment: 'Thanh toán',
      typeShip: 'Giao hàng',
      typeCancel: 'Huỷ',
      typeOther: 'Khác',
      monthOrder: 'Tháng',
      create: 'Tạo',
    },
  },
}
